import { createStyles } from '@material-ui/core';
import { spacing } from '#web-components/styles';

const styles = () => createStyles({
  description: {
    marginTop: spacing * 2,
    marginBottom: spacing * 2,
  },
});

export default styles;
